/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getTimeline.defs.js'
export * as $defs from './getTimeline.defs.js'
